import React, { useEffect, useRef, useState } from 'react';

const GSI_SRC = 'https://accounts.google.com/gsi/client';

let gsiScriptPromise;

const loadGsiScript = () => {
  gsiScriptPromise ??= new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = GSI_SRC;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => {
      gsiScriptPromise = null;
      reject(new Error('Failed to load Google sign-in'));
    };
    document.head.appendChild(script);
  });
  return gsiScriptPromise;
};

export const disableGoogleAutoSelect = () => {
  window.google?.accounts?.id?.disableAutoSelect();
};

// Renders Google's "Sign in with Google" button and calls onCredential with
// the ID token, which the API verifies against ADMIN_EMAILS.
const GoogleSignInButton = ({ onCredential }) => {
  const buttonRef = useRef(null);
  const callbackRef = useRef(onCredential);
  const [loadError, setLoadError] = useState('');
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useEffect(() => {
    callbackRef.current = onCredential;
  }, [onCredential]);

  useEffect(() => {
    if (!clientId) return;
    let cancelled = false;

    loadGsiScript()
      .then(() => {
        if (cancelled || !buttonRef.current) return;
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: ({ credential }) => callbackRef.current(credential),
        });
        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
        });
      })
      .catch((err) => {
        if (cancelled) return;
        setLoadError(err.message);
      });

    return () => {
      cancelled = true;
    };
  }, [clientId]);

  if (!clientId) {
    return <div>REACT_APP_GOOGLE_CLIENT_ID is not set.</div>;
  }

  if (loadError) {
    return <div>{loadError}</div>;
  }

  return <div ref={buttonRef} />;
};

export default GoogleSignInButton;
